import { getDefaultMargin, getDefaultMarginOverlay, getDefaultTypography, getDefaultWidthOverlay } from '../utils'

export const LoginFormDesignSettings = {
  'login-form-design-width': {
    phone: ['100%'],
    'phone-landscape': ['60%'],
    tablet: ['80%'],
    'tablet-landscape': ['50%'],
    desktop: ['50%'],
    tv: ['50%'],
    overflowSetting: getDefaultWidthOverlay,
  },
  'login-form-design-h-align': {
    phone: 'parent',
    'phone-landscape': 'parent',
    tablet: 'parent',
    'tablet-landscape': 'parent',
    desktop: 'parent',
    tv: 'parent',
  },
  'login-form-design-button-padding': {
    phone: getDefaultMargin([8, 16]),
    'phone-landscape': getDefaultMargin([8, 16]),
    tablet: getDefaultMargin([8, 16]),
    'tablet-landscape': getDefaultMargin([8, 16]),
    desktop: getDefaultMargin([8, 16]),
    tv: getDefaultMargin([8, 16]),
  },
  'login-form-design-button-size': {
    phone: 'lg',
    'phone-landscape': 'lg',
    tablet: 'lg',
    'tablet-landscape': 'lg',
    desktop: 'lg',
    tv: 'lg',
  },

  'login-form-design-margin': {
    phone: getDefaultMargin(),
    'phone-landscape': getDefaultMargin(),
    tablet: getDefaultMargin(),
    'tablet-landscape': getDefaultMargin(),
    desktop: getDefaultMargin(),
    tv: getDefaultMargin(),
    overflowSetting: getDefaultMarginOverlay,
  },

  'login-form-design-typography': {
    'login-form-design-title-typography': {
      phone: getDefaultTypography('headline-extra-small'),
      'phone-landscape': getDefaultTypography('headline-extra-small'),
      tablet: getDefaultTypography('headline-extra-small'),
      'tablet-landscape': getDefaultTypography('headline-extra-small'),
      desktop: getDefaultTypography('headline-extra-small'),
      tv: getDefaultTypography('headline-extra-small'),
    },
  },
  'login-form-design-title-color': {
    light: 'adaptive',
    dark: 'adaptive',
  },
  'login-form-design-title-color-solid': {
    light: 'primary-40',
    dark: 'primary-40',
  },
  'login-form-design-title-color-start-gradient': {
    light: 'primary-40',
    dark: 'primary-40',
  },
  'login-form-design-title-color-end-gradient': {
    light: 'primary-80',
    dark: 'primary-80',
  },
  'login-form-design-title-color-gradient-direction': {
    light: 'to-right',
    dark: 'to-right',
  },
}
